// @ts-nocheck
import constants from "@store/constants";
import DocumentLine from "@store/Library/Components/Icons/Document/DocumentLine";
import DropTrailerLine from "@store/Library/Components/Icons/DropTrailer/DropTrailerLine";
import InvoicesLine from "@store/Library/Components/Icons/Invoices/InvoicesLine";
import OrdersLine from "@store/Library/Components/Icons/Orders/OrdersLine";
import OrderUploadLine from "@store/Library/Components/Icons/OrderUpload/OrderUploadLine";
import Profile from "@store/Library/Components/Icons/Profile";
import ReportsLine from "@store/Library/Components/Icons/Reports/ReportsLine";
import ShipmentsLine from "@store/Library/Components/Icons/Shipments/ShipmentsLine";
import TaxExemptionLine from "@store/Library/Components/Icons/TaxExemption/TaxExemptionLine";
import BellLine from "@store/Library/Components/Toolkit/Icons/Bell/BellLine";
import BookmarkLine from "@store/Library/Components/Toolkit/Icons/Bookmark/BookmarkLine";
import SettingsLine from "@store/Library/Components/Toolkit/Icons/Settings/SettingsLine";

export const iconByPageType = {
    [constants.pageType.myAccount]: BellLine,
    [constants.pageType.accountSettings]: Profile,
    [constants.pageType.orderHistory]: OrdersLine,
    [constants.pageType.shipmentHistory]: ShipmentsLine,
    [constants.pageType.invoiceHistory]: InvoicesLine,
    [constants.pageType.myReports]: ReportsLine,
    [constants.pageType.orderUpload]: OrderUploadLine,
    [constants.pageType.trailerTracking]: DropTrailerLine,
    [constants.pageType.taxExemptionCertificates]: TaxExemptionLine,
    [constants.pageType.myLists]: BookmarkLine,
    [constants.pageType.userList]: SettingsLine,
};

const getIconByPageType = (pageType: string | undefined) => {
    return (pageType ? iconByPageType[pageType] : undefined) || DocumentLine;
};

export default getIconByPageType;
